import VillaArticleBig from './VillaArticleBig';

export default VillaArticleBig;
